let hasMegaMenu = false;
const $openSubmenu = $('.js-submenu-open');

$(document).ready(function ($) {
  if ($('.c-menu-mega').length > 0) {
    hasMegaMenu = true;
  }
  
  if (hasMegaMenu && (isMobile() || isTablet())) {
    console.log('Mega menu is active on mobile or tablet');
    $openSubmenu.on('click', function (e) {
      e.preventDefault();
      const $parent = $(this).parent();
      if ($parent.hasClass('has-children')) {
        $parent.children('.js-submenu').toggleClass('is-open');
        $(this).toggleClass('is-open');
      }
    });
  }
});
